exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".hero{height:100vh;position:relative;overflow:hidden}@media (min-width:48em){.hero{min-height:50rem}}@media (min-width:76.8em){.hero{min-height:70rem}}@media (min-width:99.2em){.hero{min-height:90rem}}.hero .hero__img{background-size:cover;background-position:50%}.hero .hero__img,.hero .hero__video{position:absolute;top:-4rem;right:-4rem;bottom:-4rem;left:-4rem;transition:opacity 1s,top .8s,right .8s,bottom .8s,left .8s}.hero .hero__video{overflow:hidden}.hero .hero__video video{position:fixed;top:50%;left:50%;min-width:100%;min-height:100%;width:auto;height:auto;z-index:0;transform:translateX(-50%) translateY(-50%)}.hero .hero__color-overlay{position:absolute;width:100%;height:100%}.hero .copy-hldr{padding-top:17.9rem}@media (min-width:48em){.hero .copy-hldr{padding-top:30.4rem}}@media (min-width:76.8em){.hero .copy-hldr{padding-top:30.4rem}}.hero ::-webkit-media-controls-panel,.hero ::\\--webkit-media-controls-play-button{display:none!important;-webkit-appearance:none}.hero ::-webkit-media-controls-start-playback-button{display:none!important;-webkit-appearance:none}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/ui-Hero/_index.scss
 ** module id = 188
 ** module chunks = 0
 **/